export default __webpack_public_path__ + "static/media/sign-out.1921051c.svg";